export default `/* Ids Modal Component */
:host {
  display: block;
  position: fixed;
  visibility: visible;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host(:not([visible])) {
  pointer-events: none;
  visibility: hidden;
}

.ids-modal {
  display: block;
  pointer-events: none;
}
.ids-modal[visible] {
  pointer-events: auto;
}
.ids-modal.fullsize {
  height: 100%;
}
.ids-modal.fullsize .ids-modal-container {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.ids-modal.fullsize .ids-modal-header + .ids-modal-content {
  overflow-y: auto;
}
.ids-modal:not(.scrollable) .has-scrollbar {
  overflow: hidden;
  padding: 0;
}
.ids-modal.scrollable .has-scrollbar {
  overflow: auto;
}
.ids-modal:not(.fullsize)::part(popup) {
  max-height: calc(100% - 32px);
}

.ids-modal-header {
  padding: var(--ids-modal-header-padding);
}

.ids-modal-content {
  padding: var(--ids-modal-content-padding);
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.ids-modal-header + .ids-modal-content {
  padding-block-start: 0;
}

.ids-modal-header,
.ids-modal-footer {
  align-items: center;
  display: flex;
}

.ids-modal-footer {
  margin: var(--ids-modal-footer-margin);
  border-top: 1px solid var(--ids-modal-footer-color-border);
}
.ids-modal-footer[hidden] {
  border-top: none;
}

.ids-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 64px);
}

::slotted([slot=buttons]) {
  flex-grow: 1;
  display: flex;
}

.modal-control-close {
  position: absolute;
  top: var(--ids-space-2xs);
  right: var(--ids-space-2xs);
}
.modal-control-close[dir=rtl] {
  left: var(--ids-space-2xs);
  right: unset;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-inline-start: 1px solid var(--ids-modal-footer-color-border);
}

.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {
  border-left: 1px solid var(--ids-modal-footer-color-border);
}

@media screen and (min-width: 767px) {
  ::slotted([slot=title]) {
    font-size: var(--ids-font-size-lg);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
